/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import {
  MDBCol,
  MDBPageItem,
  MDBPageNav,
  MDBPagination,
  MDBRow,
} from "mdbreact";
import Moment from "moment";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  Modal,
  Table,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import AppConfig from "../../../../config/AppConfig";

const bgImage = toAbsoluteUrl("/media/bg/bg-10.jpg");
class ManajemenUser extends Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal1 = this.closeModal1.bind(this);
    this.closeModal2 = this.closeModal2.bind(this);
    this.modalEdit = this.modalEdit.bind(this);
    this.modalAddURole = this.modalAddURole.bind(this);
    this.modalURole = this.modalURole.bind(this);
    this.modalResetPass = this.modalResetPass.bind(this);
    this.modalSuccess = this.modalSuccess.bind(this);
  }
  state = {
    // MODAL ============================
    modalEdit: false,
    modalAddURole: false,
    modalURole: false,
    modalResetPass: false,
    modalSuccess: false,
    // showDialogDelete: false,
    // ==================================
    loadingBtn: false,
    loadingBtnReset: false,
    loadingList: true,
    loadingSearch: false,
    lingkup_kordinasi: "",
    loadingDetails: true,
    // ==================================
    getUsers: [],
    getUserRoles: [],
    getRoles: [],
    getUnits: [],
    get_from: "",
    // FORM Add User Role
    id_pengguna: "",
    id_peran: "",
    id_bp: "",
    id_bp2: "",
    id_unit: "",
    id_organisasi: "",
    no_sk_penugasan: "",
    tanggal_penugasan: "",
    id_role_pengguna: "",
    // FORM Edit User
    usernameEdit: "",
    passwordEdit: "",
    nm_penggunaEdit: "",
    tempat_lahirEdit: "",
    tgl_lahirEdit: "",
    jenis_kelaminEdit: null,
    alamatEdit: "",
    ymEdit: "",
    skypeEdit: "",
    no_telEdit: "",
    no_hpEdit: "",
    jabatanEdit: "",
    // Search & Pagination
    keyword: "",
    totalData: 0,
    totalPaginationNumber: 0,
    limit: 10,
    start: 0,
    currentPage: 1,
    pageLimit: 5,
    showFrom: 0,
    ref_lingkup: [],
    filter_bp: "",
    filter_role: "",

    id_sp: "",
    nm_sp: "",
    list_option_sp: [],
    spHide: false,
    errors: [],
  };

  closeModal1() {
    this.setState({
      modalEdit: false,
      modalURole: false,
      id_pengguna: "",
      usernameEdit: "",
      passwordEdit: "",
      nm_penggunaEdit: "",
      tempat_lahirEdit: "",
      tgl_lahirEdit: "",
      jenis_kelaminEdit: "",
      alamatEdit: "",
      ymEdit: "",
      skypeEdit: "",
      no_telEdit: "",
      no_hpEdit: "",
      jabatanEdit: "",
      loadingBtn: false,
    });
  }

  closeModal2() {
    this.setState({
      modalAddURole: false,
      id_unit: "",
      id_peran: "",
      id_bp: "",
      id_role_pengguna: "",
      no_sk_penugasan: "",
      tanggal_penugasan: "",
      loadingBtn: false,
    });
  }

  closeModal3 = () => {
    this.setState({ modalResetPass: false, loadingBtnReset: false });
  };

  selectedGender = (val) => {
    this.setState({
      jenis_kelaminEdit: val.value,
    });
  };
  selectedBp = (val) => {
    this.setState({ val });
    this.setState({
      id_bp: val.value,
    });
  };
  selectedRole = (val) => {
    this.setState({ val });
    this.setState({
      id_peran: val.value,
    });
  };
  selectedUnit = (val) => {
    this.setState({ val });
    this.setState({
      id_unit: val.value,
    });
  };

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  // List ============================================================================
  componentDidMount() {

    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    if (sessiondata.i_idrole !== 1 && sessiondata.i_idrole !== 10) {
      window.location.href = "/";
    }

    this.setState({ loadingList: true });

    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[id_peran]", this.state.filter_role);
    formData.append("data[lingkup_koordinasi]", this.state.lingkup_kordinasi);

    if (sessiondata.i_idbp === 0) {
      formData.append("data[filter_bp]", this.state.filter_bp);
    } else {
      formData.append("data[filter_bp]", sessiondata.i_idbp);
    }


    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let session = "";
    if (userdata) {
      session =
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    axios
      .post(
        AppConfig.ListManajemenUser +
        "?limit=" +
        this.state.limit +
        "&start=" +
        this.state.start + session,
        formData
      )
      .then((res) => {
        this.setState(
          {
            loadingList: false,
            loadingSearch: false,
            getUsers: res.data.result.data,
            totalData: res.data.result.total_rows,
            ref_lingkup: res.data.result.ref_lingkup,
            getRoles: res.data.result.a_role,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            // console.log(this.state.getUsers);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Edit User ============================================================================
  modalEdit = (id) => {
    console.log(id);
    this.setState({ modalEdit: true, loadingDetails: true });
    axios
      .get(AppConfig.DetailsManajemenUser + id)
      .then((res) => {
        this.setState(
          {
            loadingDetails: false,
            usernameEdit: res.data.result.data.username,
            id_pengguna: id,
            nm_penggunaEdit: res.data.result.data.nm_pengguna,
            get_from: res.data.result.data.get_from,
            tempat_lahirEdit: res.data.result.data.tempat_lahir !== "null" ? res.data.result.data.tempat_lahir : "",
            tgl_lahirEdit: res.data.result.data.tgl_lahir !== "null" ? Moment(res.data.result.data.tgl_lahir).format(
              "YYYY-MM-DD"
            ) : "",
            jenis_kelaminEdit: res.data.result.data.jenis_kelamin !== "null" ? res.data.result.data.jenis_kelamin : "",
            alamatEdit: res.data.result.data.alamat !== "null" ? res.data.result.data.alamat : "",
            ymEdit: res.data.result.data.ym,
            no_telEdit: res.data.result.data.no_tel !== "null" ? res.data.result.data.no_tel : "",
            no_hpEdit: res.data.result.data.no_hp !== "null" ? res.data.result.data.no_hp : "",
          },
          () => {
            console.log(res);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  validateForm() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.nm_penggunaEdit) {
      formIsValid = false;
      errors["nm_penggunaEdit"] = "Isian nama user tidak boleh kosong.";
    }

    if (!this.state.usernameEdit) {
      formIsValid = false;
      errors["usernameEdit"] = "Isian username tidak boleh kosong.";
    }

    if (!this.state.ymEdit) {
      formIsValid = false;
      errors["ymEdit"] = "Isian email tidak boleh kosong.";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleEdit = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      var formData = new FormData();
      this.setState({ loadingBtn: true });
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      formData.append("data[id_pengguna]", this.state.id_pengguna);
      formData.append("data[username]", this.state.usernameEdit);
      formData.append("data[nm_pengguna]", this.state.nm_penggunaEdit);
      formData.append("data[tempat_lahir]", this.state.tempat_lahirEdit);
      formData.append("data[tgl_lahir]", this.state.tgl_lahirEdit !== "" ? this.state.tgl_lahirEdit : "");
      formData.append("data[jenis_kelamin]", this.state.jenis_kelaminEdit);
      formData.append("data[alamat]", this.state.alamatEdit);
      formData.append("data[ym]", this.state.ymEdit);
      formData.append("data[no_tel]", this.state.no_telEdit);
      formData.append("data[no_hp]", this.state.no_hpEdit);
      axios
        .put(AppConfig.UpdateManajemenUser + session, formData)
        .then((res) => {
          this.setState(
            {
              loadingBtn: false,
            },
            () => {
              // console.log(this.state.id_pengguna);
            }
          );
          swal({
            title: "Sukses!",
            text: "Data berhasil diubah!",
            icon: "success",
            button: "OK!",
          });
          this.componentDidMount();
          this.closeModal1();
        })
        .catch((err) => {
          swal({
            title: "Gagal!",
            text: "Gagal mengubah data!",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
        });
    }
  };

  // List User Role ============================================================================
  modalURole = (id) => {
    this.setState({ modalURole: true, loadingDetails: true });
    axios
      .get(AppConfig.ListRole + id)
      .then((res) => {
        this.setState(
          {
            getUserRoles: res.data.result.role,
            loadingDetails: false,
            id_pengguna: id,
            id_sp: "",
            nm_sp: "",
            id_unit: "",
            errors: [],
          },
          () => {
            console.log(res);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Add User Role ============================================================================
  modalAddURole = (id) => {
    this.setState({ modalAddURole: true });
    axios
      .get(AppConfig.AddRole + id)
      .then((res) => {
        this.setState({
          getRoles: res.data.result.data2[0],
          getUnits: res.data.result.units[0],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  validateFormRole() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.id_peran) {
      formIsValid = false;
      errors["id_peran"] = "Isian peran tidak boleh kosong.";
    }

    if (!this.state.id_bp) {
      formIsValid = false;
      errors["id_bp"] = "Isian bentuk pendidikan tidak boleh kosong.";
    }

    if (this.state.id_peran === '3') {
      if (!this.state.id_sp) {
        formIsValid = false;
        errors["id_sp"] = "Isian perguruan tinggi tidak boleh kosong.";
      }
    } else if (this.state.id_peran === '2013' || this.state.id_peran === '2014') {
      if (!this.state.id_unit) {
        formIsValid = false;
        errors["id_unit"] = "Isian unit tidak boleh kosong.";
      }
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleSubmitRole = (e) => {
    e.preventDefault();
    if (this.validateFormRole()) {
      var formData = new FormData();
      this.setState({ loadingBtn: true });
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          // "?token="+userdata.token+`
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      formData.append("data[id_pengguna]", this.state.id_pengguna);
      formData.append("data[id_peran]", this.state.id_peran);
      formData.append("data[id_bp]", this.state.id_bp);
      if (this.state.id_peran === "3" || this.state.id_peran === 3) {
        formData.append("data[id_organisasi]", this.state.id_sp);
      } else {
        formData.append("data[id_organisasi]", this.state.id_unit);
      }

      axios
        .post(AppConfig.SaveRole + session, formData)
        .then((res) => {
          this.setState({
            loadingBtn: false,
          });
          swal({
            title: "Sukses!",
            text: "Data berhasil diubah!",
            icon: "success",
            button: "OK!",
          });
          this.modalURole(this.state.id_pengguna);
          this.closeModal2();
        })
        .catch((err) => {
          swal({
            title: "Gagal!",
            text: "Gagal mengubah data!",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
        });
    }
  };

  // Delete Role ============================================================================
  showDialogDelete(id_pengguna, idunit, idperan) {
    // console.log(idpengguna, idorganisasi, idperan);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let ids = id_pengguna + "/" + idunit + "/" + idperan;
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(AppConfig.DeleteRole + ids + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.modalURole(this.state.id_pengguna);
            this.closeModal2();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            // alert("GAGAL")
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  showDialogDeleteUser(id_pengguna) {
    // console.log(idpengguna, idorganisasi, idperan);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(AppConfig.DeleteManajemenUser + id_pengguna + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.closeModal2();
            this.componentDidMount();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  // Reset Pass ============================================================================
  modalResetPass = () => {
    this.setState({ modalEdit: false, modalResetPass: true });
    console.log(this.state)
    console.log(this.state.id_pengguna);
  };

  handleResetPass = (e) => {
    e.preventDefault();
    this.setState({ loadingBtnReset: true });

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let idpengguna = this.state.id_pengguna;
    axios
      .get(AppConfig.ResetPassword + idpengguna + session)
      .then((res) => {
        console.log(res);
        if (res.data.status === "sukses") {
          this.closeModal3();
          this.modalSuccess();
        } else {
          this.setState({ loadingBtnReset: false });
          console.log(res.data.message);
          // modal error
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingBtnReset: false });
        // modal error
      });
  };
  modalSuccess = () => {
    this.setState({ modalSuccess: true });
  };
  closeModalSuccess = () => {
    this.setState({ modalSuccess: false });
  };

  // Searh
  onClickSearch = (e) => {
    this.setState(
      {
        loadingSearch: true,
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  ResetFilter = (e) => {
    e.preventDefault();
    this.setState(
      {
        keyword: "",
        filter_role: "",
        lingkup_kordinasi: "",
        filter_bp: "",
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onInputKeyword = (e) => {
    this.setState({
      keyword: e.target.value,
    });
  };

  selectedFilterOrganisasi = (val) => {
    this.setState({ val });
    this.setState({
      lingkup_kordinasi: val.value,
    });
  };
  // Pagination
  getPaginationGroup = () => {
    let start =
      Math.floor((this.state.currentPage - 1) / this.state.pageLimit) *
      this.state.pageLimit;
    return new Array(this.state.pageLimit)
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  pagination(e, numb) {
    let dataStart = numb * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: numb,
      },
      () => {
        this.componentDidMount();
      }
    );
  }
  firstPagination = () => {
    let first = this.state.currentPage / this.state.currentPage;
    let dataStart = first * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: first,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  prevPagination = () => {
    let prev = this.state.currentPage - 1;
    let dataStart = prev * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: prev,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  nextPagination = () => {
    let next = this.state.currentPage + 1;
    let dataStart = next * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: next,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onInputChangeName = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  onInputChangeKordinasi = (e, type) => {
    this.setState({
      lingkup_kordinasi: e.target.value,
    });

    console.log(this.state);
  };
  lastPagination = () => {
    let last = this.state.totalPaginationNumber;
    let dataStart = last * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: last,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  onChangeSP = (e) => {
    if (e.target.value !== "") {
      var str = e.target.value;
      if (str.length > 2) {

        var formData = new FormData();
        formData.append("data[keyword]", e.target.value);
        formData.append("data[id_bp]", this.state.id_bp);

        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        axios
          .post(AppConfig.SearchPT + session, formData)
          .then((res) => {
            this.setState({ list_option_sp: res.data.result.data });
          })
          .catch((err) => {
            console.log(err);
          });
        this.setState({ spHide: false, nm_sp: e.target.text });
      } else {
        this.setState({
          nm_sp: e.target.text,
          spHide: true,
        });
      }
    } else {
      this.setState({
        nm_sp: e.target.text,
        spHide: true,
      });
    }
  };

  onClickSPvalue = (e) => {

    e.target.value = e.target.getAttribute('value');
    e.target.text = e.currentTarget.innerHTML;

    this.setState({ id_sp: e.target.value, nm_sp: e.target.text, spHide: true, errors: [] });
  }

  deletePT = (e) => {
    e.preventDefault();
    this.setState({ id_sp: "", nm_sp: "", spHide: true });
  }

  // Layout ============================================================================
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    const {
      ref_lingkup,
      lingkup_kordinasi,
      filter_bp,
      filter_role,
    } = this.state;
    var i = 0;
    let result_ref = [];
    for (var key in ref_lingkup) {
      result_ref[i] = {
        name: key,
        result: ref_lingkup[key],
      };
      i++;
    }
    const jenisKelamin = [
      { label: "Laki-laki", value: "L" },
      { label: "Perempuan", value: "P" },
    ];

    let no = this.state.showFrom - 1;

    let ii = 0;
    let list_user = [];
    if (this.state.getUsers !== undefined) {
      for (var key in this.state.getUsers) {
        list_user[ii] = {
          result: this.state.getUsers[key],
        };
        ii++;
      }
    }
    let list_user_role = [];
    if (this.state.getUserRoles !== undefined) {
      for (var key_role in this.state.getUserRoles) {
        list_user_role[ii] = {
          result: this.state.getUserRoles[key_role],
        };
        ii++;
      }
    }
    let list_role = [];
    for (var obj in this.state.getRoles) {
      if (this.state.getRoles.hasOwnProperty(obj)) {
        list_role[ii] = {
          value: obj,
          label: this.state.getRoles[obj],
        };
        ii++;
      }
    }
    let list_unit = [];
    for (var val in this.state.getUnits) {
      if (this.state.getUnits.hasOwnProperty(val)) {
        list_unit[ii] = {
          value: val,
          label: this.state.getUnits[val],
        };
        ii++;
      }
    }

    let data_option = [];
    this.state.list_option_sp.map((list, i) => {
      data_option.push(<div value={list.id_sp} style={{ padding: '10px', backgroundColor: '#f4f4f4' }} className="bg-hover-primary text-hover-white" onClick={this.onClickSPvalue}>{list.nm_lemb}</div>);
    });

    let resetKeyword = <></>;
    if (this.state.keyword !== "") {
      resetKeyword = (
        <i
          onClick={(e) => this.onClickResetKeyword(e)}
          className="flaticon-close text-dark"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "25px",
            bottom: "10px",
            cursor: "pointer",
          }}
        ></i>
      );
    }

    let optionsBP = [];

    if (JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 0 || JSON.parse(localStorage.getItem("sessiondata")).i_idbp === "null") {
      optionsBP.push({ value: "0", label: "Semua" });
      optionsBP.push({ value: "1", label: "Akademik" });
      optionsBP.push({ value: "2", label: "Vokasi" });
    } else if (JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 1) {
      optionsBP.push({ value: "1", label: "Akademik" });
    } else if (JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 2) {
      optionsBP.push({ value: "2", label: "Vokasi" });
    }

    let loadingSearch = <></>;
    if (this.state.loadingSearch === true) {
      loadingSearch = (
        <i
          className="spinner spinner-white"
          style={{ marginRight: "20px" }}
        ></i>
      );
    }

    let searchComponent = <></>;
    searchComponent = (
      <>
        <div className="row">
          <div className="col-md-6"></div>
          <div className="col-md-2 text-left"></div>
          <div className="col-md-4 text-right">
            <Link to="/add-user">
              <Button
                variant="primary"
                style={{
                  padding: "12px",
                  width: "50%",
                }}
              >
                <i
                  className="flaticon-add"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
                &nbsp; Tambah User
              </Button>
            </Link>
          </div>
        </div>
      </>
    );

    let pagination = <></>;
    if (this.state.loadingList === false) {
      pagination = (
        <>
          <div className="col-md-8" style={{ textAlign: "center" }}>
            <MDBRow>
              <MDBCol>
                <MDBPagination circle>
                  <MDBPageItem
                    className={`prev ${this.state.currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.firstPagination(e)}
                    >
                      <span>First</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    className={`prev ${this.state.currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => this.prevPagination(e)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  {this.getPaginationGroup()
                    .filter(
                      (index) => index <= this.state.totalPaginationNumber
                    )
                    .map((item, index) => (
                      <MDBPageItem
                        active={this.state.currentPage === item ? true : false}
                        key={index}
                      >
                        <MDBPageNav
                          className="page-link"
                          onClick={(e) => this.pagination(e, item)}
                        >
                          {item}
                        </MDBPageNav>
                      </MDBPageItem>
                    ))}
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                        this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.nextPagination(e)}
                    >
                      &raquo;
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                        this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.lastPagination(e)}
                    >
                      Last
                    </MDBPageNav>
                  </MDBPageItem>
                </MDBPagination>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      );
    }

    return (
      <>
        <div
          className="row row-paddingless"
          style={{
            backgroundImage: `url(${bgImage})`,
            padding: "2%",
            borderRadius: "5px",
            marginBottom: "20px",
          }}
        >
          <div className="col-md-12 text-white" style={{ textAlign: "left" }}>
            <h2 className="font-weight">Manajemen User</h2>
            <hr />
          </div>
          <div className="col-md-12 text-white" style={{ textAlign: "" }}>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Kata Kunci
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="text"
                    value={this.state.keyword}
                    onChange={(e) => this.onInputChangeName(e, "keyword")}
                    className={`form-control form-control-lg form-control-solid `}
                    placeholder="Masukan keyword : Username / Nama Pengguna"
                    name="keyword"
                  />
                </div>
              </div>
            </div>
            {this.state.id_bp2 === "" ? (
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 text-white">
                  Bentuk Pendidikan
                </label>
                <div className="col-lg-9 col-xl-6">
                  <select
                    value={filter_bp}
                    onChange={(e) => this.onInputChangeName(e, "filter_bp")}
                    className="form-control form-control-lg form-control-solid"
                    name="language"
                  >
                    {
                      (JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 0 || JSON.parse(localStorage.getItem("sessiondata")).i_idbp === "null") ?
                        <>
                          <option value="0">Semua</option>
                          <option value="1">Akademik</option>
                          <option value="2">Vokasi</option>
                        </>
                        : (JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 1) ?
                          <>
                            <option value="1">Akademik</option>
                          </>
                          : (JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 2) ?
                            <>
                              <option value="2">Vokasi</option>
                            </>
                            : ""
                    }
                  </select>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 text-white">Roles</label>
              <div className="col-lg-9 col-xl-6">
                <select
                  value={filter_role}
                  onChange={(e) => this.onInputChangeName(e, "filter_role")}
                  className="form-control form-control-lg form-control-solid"
                  name="filter_role"
                >
                  <option value="">Semua Peran</option>
                  {list_role.map((list, i) => (
                    <option value={list.value}>{list.label}</option>
                  ))}
                </select>
              </div>
            </div>
            {userdata.i_idrole === "2013" ||
              userdata.i_idrole === "2014" ||
              userdata.i_idrole === 2013 ||
              userdata.i_idrole === 2014 ? (
              ""
            ) : (
              <>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 text-white">
                    Lingkup Koordinasi
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      value={lingkup_kordinasi}
                      onChange={(e) =>
                        this.onInputChangeKordinasi(e, "lingkup_kordinasi")
                      }
                      className="form-control form-control-lg form-control-solid"
                      name="language"
                    >
                      <option value="">Semua Unit</option>
                      {result_ref.map((list, i) => (
                        <option value={list.name}>{list.result}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            )}
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label"></label>
              <div
                className="col-lg-9 col-xl-6"
                style={{ textAlign: "center" }}
              >
                <Button variant="primary" onClick={this.onClickSearch}>
                  Filter Data &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-search"></span>
                </Button>
                <Button
                  variant="default"
                  onClick={this.ResetFilter}
                  style={{ marginLeft: "10px" }}
                >
                  Reset &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-times"></span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Card style={{ padding: "2%" }}>
          {
            (JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 1 || JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 10) ?
              <div className="row" style={{ marginBottom: "20px" }}>
                <div className="col-md-12">{searchComponent}</div>
              </div>
              : ""
          }
          {/*========================================== Begin Table ========================================== */}
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    width: "5%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    width: "20%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Nama User
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Username
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Bentuk Pendidikan
                </th>
                <th
                  className="text-center"
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingList === true ? (
                <tr>
                  <td colSpan="6">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : list_user.length > 0 ? (
                list_user.map((list) => (
                  <tr key={list.result.id_pengguna}>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {(no = no + 1)}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_pengguna}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.username}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.is_no_role === 1 ?
                        "Belum Memiliki Role"
                        : list.result.id_bp !== "null"
                          ? list.result.id_bp === 1
                            ? "Akademik"
                            : list.result.id_bp === 2
                              ? "Vokasi"
                              : list.result.id_bp === 0
                                ? "Semua"
                                : "Semua"
                          : "Semua"}
                    </td>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {
                        (JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 1 || JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 10) ?
                          <ButtonToolbar
                            onClick={() => this.modalEdit(list.result.id_pengguna)}
                            className="btn btn-icon btn-primary btn-sm"
                            style={{
                              minWidth: "50px",
                              marginRight: "10px",
                              borderRadius: "12px",
                            }}
                          >
                            <div>
                              <i
                                className="flaticon-eye"
                                style={{ color: "#FFFFFF", fontSize: "16px" }}
                              ></i>
                            </div>
                          </ButtonToolbar> : ""
                      }
                      {
                        (JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 1 || JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 10) ?
                          <ButtonToolbar
                            onClick={() => this.modalURole(list.result.id_pengguna)}
                            className="btn btn-icon btn-info btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                            }}
                          >
                            <div>
                              <i
                                className="flaticon2-list-1"
                                style={{ color: "#FFFFFF", fontSize: "14px" }}
                              ></i>
                            </div>
                          </ButtonToolbar>
                          : ""}
                      {
                        ((JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 1 || JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 10) &&
                          list.result.id_pengguna !== JSON.parse(localStorage.getItem("userdata")).id_pengguna) ?
                          <ButtonToolbar
                            onClick={() =>
                              this.showDialogDeleteUser(
                                list.result.id_pengguna
                              )
                            }
                            className="btn btn-icon btn-danger btn-sm"
                            style={{
                              minWidth: "50px",
                              marginLeft: "10px",
                              borderRadius: "12px",
                            }}
                          >
                            <div>
                              <i
                                className="flaticon-delete"
                                style={{
                                  color: "#FFFFFF",
                                  fontSize: "14px",
                                }}
                              ></i>
                            </div>
                          </ButtonToolbar>
                          : ""}
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </>
              )}
            </tbody>
          </Table>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-4 text-left">
              {" "}
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Page <strong>{this.state.currentPage}</strong> of{" "}
                <strong>{this.state.totalPaginationNumber}</strong>
              </label>
            </div>
            <div className="col-md-4">{pagination}</div>
            <div className="col-md-4 text-right">
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Showing <strong>{this.state.showFrom}</strong> to{" "}
                <strong>
                  {this.state.showFrom + this.state.getUsers.length - 1}
                </strong>{" "}
                of <strong>{this.state.totalData}</strong> Data
              </label>
            </div>
          </div>
          {/*========================================== End Table ========================================== */}
        </Card>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalEdit}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Details User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Form>
                  <Form.Row>
                    <Form.Group as={Col} controlId="nm_penggunaEdit">
                      <Form.Label>Nama Lengkap  <span className="text-danger"> *</span></Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.nm_penggunaEdit}
                        onChange={(e) => this.onInputForm(e, "nm_penggunaEdit")}
                        required
                      />
                      <div className="text-danger">
                        {this.state.errors.nm_penggunaEdit}
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} controlId="jenis_kelaminEdit">
                      <Form.Label>Jenis Kelamin</Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable={false}
                        autoFocus={false}
                        options={jenisKelamin}
                        placeholder="Pilih Jenis Kelamin"
                        defaultValue={{
                          label:
                            this.state.jenis_kelaminEdit === "L"
                              ? "Laki-laki"
                              : "Perempuan",
                        }}
                        onChange={this.selectedGender}
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="tempat_lahirEdit">
                      <Form.Label>Tempat Lahir</Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          this.state.tempat_lahirEdit
                        }
                        onChange={(e) =>
                          this.onInputForm(e, "tempat_lahirEdit")
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} controlId="tgl_lahirEdit">
                      <Form.Label>Tanggal Lahir</Form.Label>
                      <Form.Control
                        type="date"
                        value={this.state.tgl_lahirEdit}
                        onChange={(e) => this.onInputForm(e, "tgl_lahirEdit")}
                        placeholder="Tanggal Lahir"
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="alamatEdit">
                      <Form.Label>Alamat</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.alamatEdit
                        }
                        onChange={(e) => this.onInputForm(e, "alamatEdit")}
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="usernameEdit">
                      <Form.Label>Username <span className="text-danger"> *</span></Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.usernameEdit}
                        onChange={(e) => this.onInputForm(e, "usernameEdit")}
                        required
                      />
                      <div className="text-danger">
                        {this.state.errors.usernameEdit}
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} controlId="ymEdit">
                      <Form.Label>Alamat Email <span className="text-danger"> *</span></Form.Label>
                      <Form.Control
                        type="email"
                        value={this.state.ymEdit}
                        onChange={(e) => this.onInputForm(e, "ymEdit")}
                        required
                      />
                      <div className="text-danger">
                        {this.state.errors.ymEdit}
                      </div>
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="no_telEdit">
                      <Form.Label>No. Telp</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.no_telEdit
                        }
                        onChange={(e) => this.onInputForm(e, "no_telEdit")}
                      />
                    </Form.Group>
                    <Form.Group as={Col} controlId="no_hpEdit">
                      <Form.Label>No. HP (WhatsApp)</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.no_hpEdit
                        }
                        onChange={(e) => this.onInputForm(e, "no_hpEdit")}
                      />
                    </Form.Group>
                  </Form.Row>
                </Form>
                <div style={{ textAlign: "center" }}>
                  {/* <Link to={"/reset-password/" + this.state.id_pengguna}> */}
                  <Button
                    onClick={() => this.modalResetPass()}
                    style={{
                      width: "250px",
                    }}
                    variant="warning"
                  >
                    RESET PASSWORD
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleEdit}
                disabled={this.state.loadingBtn}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {this.state.loadingBtn && (
                  <i className="ml-3 spinner spinner-white"></i>
                )}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Detail ========================================== */}

        {/*========================================== Begin Modal User Role ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalURole}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>List User Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row" style={{ marginBottom: "20px" }}>
                  <div className="col-md-12">
                    <div style={{ float: "right" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Button
                            variant="primary"
                            onClick={() =>
                              this.modalAddURole(this.state.id_pengguna)
                            }
                          >
                            <i
                              className="flaticon-add"
                              style={{ color: "#ffffff", fontSize: "14px" }}
                            ></i>
                            &nbsp; Tambah Role
                          </Button>
                        </span>
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
                {/*========================================== Begin Table ========================================== */}
                <Table responsive style={{ overflow: "auto" }}>
                  <thead
                    className="text-white"
                    style={{ backgroundColor: "#3047ad" }}
                  >
                    <tr>
                      <th
                        className="text-center"
                        style={{
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                        }}
                      >
                        Nama Role
                      </th>
                      <th
                        className="text-center"
                        style={{
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                        }}
                      >
                        Nama Unit
                      </th>
                      <th
                        className="text-center"
                        style={{
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                        }}
                      >
                        Bentuk Pendidikan
                      </th>
                      <th
                        className="text-center"
                        style={{
                          width: "100px",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                        }}
                      >
                        Aksi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.loadingList === true ? (
                      <tr>
                        <td colSpan="4">
                          <LinearProgress color="secondary" variant="query" />
                        </td>
                      </tr>
                    ) : list_user_role.length > 0 ? (
                      list_user_role.map((list) => (
                        <tr key={list.result.id_peran}>
                          <td
                            className="text-center"
                            style={{ verticalAlign: "middle" }}
                          >
                            {list.result.nm_peran === "null"
                              ? "-"
                              : list.result.nm_peran}
                          </td>
                          <td
                            className="text-center"
                            style={{ verticalAlign: "middle" }}
                          >
                            {list.result.nm_organisasi}
                          </td>
                          <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                            {list.result.id_bp !== "null"
                              ? list.result.id_bp === 1
                                ? "Akademik"
                                : list.result.id_bp === 2
                                  ? "Vokasi"
                                  : list.result.id_bp === 0
                                    ? "Semua"
                                    : "Semua"
                              : "Semua"}
                          </td>
                          <td className="text-center">
                            {
                              (list.result.id_pengguna !== JSON.parse(localStorage.getItem("userdata")).id_pengguna
                                ||
                                list.result.id_peran !== JSON.parse(localStorage.getItem("sessiondata")).i_idrole
                                ||
                                list.result.id_bp !== JSON.parse(localStorage.getItem("sessiondata")).i_idbp) ?
                                <ButtonToolbar
                                  onClick={() =>
                                    this.showDialogDelete(
                                      list.result.id_pengguna,
                                      list.result.id_organisasi,
                                      list.result.id_peran
                                    )
                                  }
                                  className="btn btn-icon btn-danger btn-sm"
                                  style={{
                                    minWidth: "50px",
                                    marginLeft: "10px",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <div>
                                    <i
                                      className="flaticon-delete"
                                      style={{
                                        color: "#FFFFFF",
                                        fontSize: "14px",
                                      }}
                                    ></i>
                                  </div>
                                </ButtonToolbar>
                                : <div className="text-xs font-italic">Role ini tidak bisa di hapus, dikarenakan sedang Anda gunakan.</div>}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          <em>Data does not exist</em>
                        </td>
                      </>
                    )}
                  </tbody>
                </Table>
                {/*========================================== End Table ========================================== */}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal User Role ========================================== */}

        {/*========================================== Begin Modal Add Role ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalAddURole}
          onHide={this.closeModal2}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Assign Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Form>
                  <Form.Group as={Col} controlId="roleSelect">
                    <Form.Label>Role <span className="text-danger">*</span></Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      autoFocus={true}
                      options={list_role}
                      placeholder="Cari nama role"
                      onChange={this.selectedRole}
                    />
                    <div className="text-danger">
                      {this.state.errors.id_peran}
                    </div>
                  </Form.Group>
                  {
                    (this.state.id_peran === "2013" || this.state.id_peran === "2014") ?
                      <Form.Group as={Col} controlId="unitSelect">
                        <Form.Label>Unit <span className="text-danger">*</span></Form.Label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isSearchable={true}
                          autoFocus={false}
                          options={list_unit}
                          placeholder="Cari nama unit"
                          onChange={this.selectedUnit}
                        />
                        <div className="text-danger">
                          {this.state.errors.id_unit}
                        </div>
                      </Form.Group>
                      : ""}
                  <Form.Group as={Col} controlId="roleSelect">
                    <Form.Label>Bentuk Pendidikan <span className="text-danger">*</span></Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      autoFocus={true}
                      options={optionsBP}
                      placeholder="Cari bentuk pendidikan"
                      onChange={this.selectedBp}
                    />
                    <div className="text-danger">
                      {this.state.errors.id_bp}
                    </div>
                  </Form.Group>
                  {
                    (this.state.id_peran === "3" && this.state.id_bp !== "") ?
                      <Form.Group as={Col} controlId="unitSelect">
                        <Form.Label>Perguruan Tinggi <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Cari nama atau kode perguruan tinggi ..."
                          value={this.state.nm_sp}
                          onChange={(e) => this.onChangeSP(e)}
                          required
                        />
                        <div hidden={this.state.spHide}>
                          {data_option}
                        </div>
                        {
                          (this.state.id_sp !== "") ?
                            <div className="text-danger text-right">
                              <button
                                type="button"
                                className="btn mt-2 btn-danger text-weight-bold"
                                style={{ fontSize: '11px' }}
                                onClick={this.deletePT}
                              >
                                <i
                                  className="flaticon-delete"
                                  style={{ color: "#FFFFFF", fontSize: "11px" }}
                                ></i>
                                Hapus Perguruan Tinggi
                              </button>
                            </div>
                            : ""
                        }
                        <div className="text-danger">
                          {this.state.errors.id_sp}
                        </div>
                      </Form.Group>
                      : ""
                  }
                </Form>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleSubmitRole}
                disabled={this.state.loadingBtn}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {this.state.loadingBtn && (
                  <i className="ml-3 spinner spinner-white"></i>
                )}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.closeModal2}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Add Role ========================================== */}

        {/*========================================== Begin Modal Confirm Reset Pass ========================================== */}
        <>
          <Modal
            size="lg"
            show={this.state.modalResetPass}
            onHide={this.closeModal3}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Reset Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ textAlign: "center" }}>
                <i
                  className="flaticon-warning-sign"
                  style={{ color: "#FFA800", fontSize: "72px" }}
                ></i>
              </div>
              <div style={{ textAlign: "center" }}>
                {this.state.get_from === "simlemkerma" ? (
                  <h1>Reset password user {this.state.usernameEdit}?</h1>
                ) : (
                  <h1>Oops.. Sorry</h1>
                )}
              </div>
              <div style={{ textAlign: "center" }}>
                <br />
                {this.state.get_from === "simlemkerma" ? (
                  <label>
                    Password akan secara otomatis diubah oleh sistem
                    <br />
                    Klik YA untuk melanjutkan
                  </label>
                ) : (
                  <label>
                    Reset password hanya berlaku untuk akun dari SPMI
                    <br />
                    Klik TUTUP untuk kembali
                  </label>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div style={{ textAlign: "right" }}>
                {this.state.get_from === "simlemkerma" ? (
                  <Button
                    onClick={this.handleResetPass}
                    disabled={this.state.loadingBtnReset}
                    style={{
                      marginRight: "1vw",
                      color: "white",
                      width: "120px",
                    }}
                    variant="warning"
                  >
                    <b>YA</b>
                    {this.state.loadingBtnReset && (
                      <i className="ml-3 spinner spinner-white"></i>
                    )}
                    &nbsp;&nbsp;
                  </Button>
                ) : (
                  ""
                )}
              </div>
              <Button
                disabled={this.state.loadingBtnReset}
                variant="secondary"
                style={{
                  width: "120px",
                }}
                onClick={this.closeModal3}
              >
                {this.state.get_from === "simlemkerma" ? "TIDAK" : "TUTUP"}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
        {/*========================================== End Modal Confirm Reset Pass ========================================== */}
        {/*========================================== Begin Modal Success ========================================== */}
        <Modal
          show={this.state.modalSuccess}
          onHide={this.closeModalSuccess}
          keyboard={false}
        >
          <Modal.Body>
            <div style={{ textAlign: "center" }}>
              <i
                className="flaticon2-check-mark"
                style={{ color: "#1BC5BD", fontSize: "72px" }}
              ></i>
            </div>
            <div style={{ textAlign: "center" }}>
              <h1>Sukses!</h1>
            </div>
            <div style={{ textAlign: "center" }}>
              <br />
              <label>
                Password user {this.state.usernameEdit} berhasil di reset,
                <br />
                password yang berlaku adalah username{" "}
                <b>{this.state.usernameEdit}</b>.
              </label>
            </div>
            <br />
            <div style={{ textAlign: "center" }}>
              <Button
                onClick={() => this.closeModalSuccess()}
                style={{
                  width: "90px",
                }}
                variant="primary"
              >
                OK!
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {/*========================================== End Modal Success ========================================== */}
      </>
    );
  }
}
export default ManajemenUser;
